import { ItemTypes } from './ItemTypes';

export const BasePositions: string[] = [ItemTypes.FirstBase, ItemTypes.SecondBase, ItemTypes.ThirdBase, ItemTypes.Remove];
